var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { businessService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var WarningService = /** @class */ (function (_super) {
    __extends(WarningService, _super);
    function WarningService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 添加警告
     */
    WarningService.prototype.addWarning = function (data, loading) {
        return this.netService.send({
            server: businessService.warningController.addWarning,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改警告
     */
    WarningService.prototype.modifyWarning = function (data, loading) {
        return this.netService.send({
            server: businessService.warningController.modifyWarning,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除警告
     */
    WarningService.prototype.deleteWarning = function (id, loading) {
        return this.netService.send({
            server: businessService.warningController.deleteWarning,
            data: {
                id: id
            },
            loading: loading
        });
    };
    /**
     * 查询警告
     */
    WarningService.prototype.findAllWarning = function (data, page, sort, loading) {
        return this.netService.send({
            server: businessService.warningController.findAllWarning,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 根据caseId查询警告
     */
    WarningService.prototype.getWarningByCaseId = function (caseId) {
        return this.netService.send({
            server: businessService.warningController.getWarningByCaseId,
            data: {
                caseId: caseId
            }
        });
    };
    __decorate([
        Inject(NetService)
    ], WarningService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], WarningService.prototype, "addWarning", null);
    __decorate([
        Debounce()
    ], WarningService.prototype, "modifyWarning", null);
    __decorate([
        Debounce()
    ], WarningService.prototype, "deleteWarning", null);
    __decorate([
        Debounce()
    ], WarningService.prototype, "findAllWarning", null);
    return WarningService;
}(Service));
export { WarningService };
